import type { OrderPayload } from '@/lib/types/orderPayload';

const LOG_PREFIX = '[shipping-estimate]';

/** Dev-only structured logs for the cart shipping estimate flow. */
export function logShippingEstimate(
  step: string,
  details?: Record<string, unknown>,
): void {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  const payload = details ? ` ${JSON.stringify(details)}` : '';
  console.log(`${LOG_PREFIX} ${step}${payload}`);
}

export function describeOrderShippingSnapshot(
  order: OrderPayload | null | undefined,
): Record<string, unknown> {
  if (!order) {
    return { order: null };
  }

  return {
    token: order.token,
    checkoutState: order.states?.checkout,
    orderState: order.states?.order,
    shipmentId: order.shipments?.[0]?.id ?? null,
    shipmentMethod: order.shipments?.[0]?.method ?? null,
    shippingPricing: order.pricing?.shipping ?? null,
    fulfillmentMethod: order.fulfillment?.method ?? null,
    hasShippingAddress: Boolean(
      order.fulfillment?.shippingAddress?.street || order.fulfillment?.deliveryAddress?.street,
    ),
    billingProvince: order.billing?.provinceCode ?? null,
  };
}
